let firewallOptions = [
    {
        type: 'DNS',
        portRange: '53',
        minPort: '53',
        maxPort: '53',
        protocol: 'tcp'
    },
    {
        type: 'HTTP',
        portRange: '80',
        minPort: '80',
        maxPort: '80',
        protocol: 'tcp'
    },
    {
        type: 'HTTPS',
        portRange: '443',
        minPort: '443',
        maxPort: '443',
        protocol: 'tcp'
    },
    {
        type: 'MySQL',
        portRange: '3306',
        minPort: '3306',
        maxPort: '3306',
        protocol: 'tcp'
    },
    {
        type: 'IMAP',
        portRange: '143',
        minPort: '143',
        maxPort: '143',
        protocol: 'tcp'
    },
    {
        type: 'IMAPS',
        portRange: '993',
        minPort: '993',
        maxPort: '993',
        protocol: 'tcp'
    },
    {
        type: 'LDAP',
        portRange: '389',
        minPort: '389',
        maxPort: '389',
        protocol: 'tcp'
    },
    {
        type: 'MS SQL',
        portRange: '1433',
        minPort: '1433',
        maxPort: '1433',
        protocol: 'tcp'
    },
    {
        type: 'POP3',
        portRange: '110',
        minPort: '110',
        maxPort: '110',
        protocol: 'tcp'
    },
    {
        type: 'POP3S',
        portRange: '995',
        minPort: '995',
        maxPort: '995',
        protocol: 'tcp'
    },
    {
        type: 'RDP',
        portRange: '3389',
        minPort: '3389',
        maxPort: '3389',
        protocol: 'tcp'
    },
    {
        type: 'SMTP',
        portRange: '25',
        minPort: '25',
        maxPort: '25',
        protocol: 'tcp'
    },
    {
        type: 'SMTPS',
        portRange: '465',
        minPort: '465',
        maxPort: '465',
        protocol: 'tcp'
    },
    {
        type: 'SSH',
        portRange: '22',
        minPort: '22',
        maxPort: '22',
        protocol: 'tcp'
    },
    {
        type: 'ALL TCP',
        portRange: 'All ports',
        minPort: '1',
        maxPort: '65535',
        protocol: 'tcp'
    },
    {
        type: 'ALL UDP',
        portRange: 'All ports',
        minPort: '1',
        maxPort: '65535',
        protocol: 'udp'
    },
    {
        type: 'ALL ICMP',
        portRange: '',
        minPort: null,
        maxPort: null,
        protocol: 'icmp'
    },
    {
        type: 'Custom',
        portRange: '',
        minPort: '',
        maxPort: '',
        protocol: ''
    },
    {
        type: 'All',
        portRange: 'any',
        minPort: null,
        maxPort: null,
        protocol: 'any'
    }
];
export default firewallOptions;